// utils/botUrlUtils.js
import Hashids from 'hashids';

const salt = process.env.REACT_APP_HASH_SALT;
const minLength = parseInt(process.env.REACT_APP_HASH_LENGTH) || 16;
const botName = process.env.REACT_APP_BOT_NAME;

const hashids = new Hashids(salt, minLength);

export const generateBotUrl = (externalId) => {
    const hash = externalId ? hashids.encode(externalId) : "";
    return `https://t.me/${botName}?start=gfi_e_${hash}`;
};